// Case-insensitive and number-aware, so "acme" sits beside "Acme" and
// "Campaign 2" comes before "Campaign 10".
const nameCollator = new Intl.Collator("en", {
  numeric: true,
  sensitivity: "base",
});

export const compareNames = (first: string, second: string): number =>
  nameCollator.compare(first, second);

export const sortByName = <T extends { name: string }>(items: T[]): T[] =>
  [...items].sort((itemA, itemB) => compareNames(itemA.name, itemB.name));
